const config = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || "/api",
  STAGE: import.meta.env.VITE_APP_STAGE || "dev",
  logrocket: import.meta.env.VITE_LOGROCKET_ENABLED === "true",
  CDN_URL: import.meta.env.VITE_CDN_URL || "https://cdn.westprop.com",
  whiteLogo:
    import.meta.env.VITE_WHITE_LOGO ||
    "https://cdn.westprop.com/logos/westprop-white.png",
  blueLogo:
    import.meta.env.VITE_BLUE_LOGO ||
    "https://cdn.westprop.com/logos/westprop-blue.png",
};

export default config;
